import React, { Component, PropTypes } from 'react';
import Mobile from './projectComponents/Mobile.js';
import TechStackItem from './projectComponents/TechStackItem';

const { Link } = require('react-router');

var Modal = require('react-modal');

var appElement = document.getElementById('root');
Modal.setAppElement(appElement);


const customStyles = {
  content : {
    position: 'fixed',
    top                   : '10%',
    left                  : '5%',
    right                 : '5%',
    bottom                : 'auto',
    height: '90%'   ,
    width: '90%'   ,
    overflow: 'scroll',
  }
};


class BabyProject extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state ={
      modalIsOpen: false
    }
  }

  getInitialState() {
    this.setState({ modalIsOpen: false });
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.refs.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  render() {
    const { project } = this.props;
    const techStackItems = project.tech_stack.map((tech, index) => {
      return <TechStackItem key={index} tech={tech}/>;
    });

    return (
      <div className="baby-project-container col-xs-12 col-md-12">
        
        <div className="image-container" >
              <a href={project.project_url} target="_blank">
                <h2 className="project-title">{project.title}</h2>
              </a>

              <div className="screenshot-container">
                <Link to={project.case_study} params={project}><img className='project-bg' src={project.desktop_image}/> </Link>
              </div>
        </div>
        
        <Modal isOpen={this.state.modalIsOpen} onAfterOpen={this.afterOpenModal} onRequestClose={this.closeModal} style={customStyles} >

          <button className='close-btn' onClick={this.closeModal.bind(this)}>close</button>
         
          
          <div className="modal-project-info col-md-12 col-xs-12">
              <a href={project.project_url} target="_blank">
                <h2 className='skinny'>{project.title}</h2>
              </a>

              <a href={project.github_url} target="_blank">
                {project.github_url !== '' ? 'Github' : null}
              </a>

              <div className="col-md-12 col-xs-12">
                    <div className="col-md-6 col-xs-6">
                   

                    <h3 className='skinny'>Role</h3>
                    <div>{project.role}</div>
                    </div>

                    <div classNAme="col-md-6 col-xs-6">
                    <h3 className='skinny'>Tech Stack</h3>
                    <div className="tech-icon-container">{techStackItems}</div>
                    </div>
              </div>

              <div className="col-md-12 col-xs-12">
              <h3 className='skinny'>Background</h3>
              <div>{project.background}</div>
              </div>
          
          </div>

          <div className="modal-screenshot-container col-md-12 col-xs-12">
              <img src={project.desktop_image}/>
              { project.mobile_image !== '' ? <Mobile image={project.mobile_image}/> : null }
          </div>  

  


          </Modal>
      </div>
    );
  }
}

BabyProject.propTypes = {
  project: PropTypes.object.isRequired
};


module.exports = BabyProject



/** WEBPACK FOOTER **
 ** ./src/components/BabyProject.js
 **/